import React, { useState } from 'react';
import { getPlaceholderImage } from '../utils/imagePlaceholder';
import { getMediaUrl } from '../utils/mediaUrl'; // ✅ Import shared utility

const SafeImage = ({ 
  src, 
  alt, 
  className = '', 
  width = 800, 
  height = 600,
  placeholderText = 'Image'
}) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleError = () => {
    setError(true);
    setLoading(false);
  };

  const handleLoad = () => {
    setLoading(false);
  };

  // ✅ Use shared utility instead of local function
  const imageUrl = getMediaUrl(src);

  if (!imageUrl || error) {
    return (
      <img 
        src={getPlaceholderImage(width, height, placeholderText)} 
        alt={alt} 
        className={className}
      />
    );
  }

  return (
    <>
      {loading && (
        <div 
          className={`${className} skeleton-image`}
          style={{ 
            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
            animation: 'shimmer 1.5s infinite'
          }}
        />
      )}
      <img 
        src={imageUrl} 
        alt={alt} 
        className={className}
        onError={handleError}
        onLoad={handleLoad}
        style={{ display: loading ? 'none' : 'block' }}
      />
    </>
  );
};

export default SafeImage;